var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProductIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_238_4889)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4338 0.5H14.8997V3.28467H13.4338V0.5ZM16.0756 3.59478L17.0335 0.979883L18.4095 1.48398L17.4515 4.09888L16.0756 3.59478ZM9.92461 1.48491L11.3006 0.980859L12.2586 3.59575L10.8826 4.0998L9.92461 1.48491ZM20.8912 6.85078H15.3909L16.5643 9.03882H22.0646L20.8912 6.85078ZM7.44219 6.85078L6.2688 9.03882H11.769L12.9424 6.85078H7.44219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6875 10.5043L14.1667 7.66797L12.6459 10.5043H7.19604V13.9259C7.8311 13.5849 8.81694 13.2551 10.2532 13.2551C11.8268 13.2551 12.8316 13.686 13.434 14.0993C13.6357 14.238 13.7926 14.3753 13.9103 14.493H16.8668C17.6646 14.493 18.3685 14.9053 18.7755 15.5277L21.1365 13.9019L21.1374 13.9009V10.5043H15.6875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7797 13.0779C23.7015 13.2103 22.5745 14.4253 22.2311 14.882L22.1593 14.9778L21.1373 15.6817L19.1286 17.0652C19.1179 17.1503 19.1023 17.2346 19.0816 17.3178C18.8379 18.3144 17.9371 19.0555 16.8667 19.0555H11.9419V17.5899H16.8667C17.108 17.5899 17.3249 17.4848 17.4739 17.3178C17.6155 17.16 17.6897 16.9531 17.6808 16.7413C17.6629 16.3005 17.2843 15.9597 16.843 15.9597H13.1476L12.9595 15.627C12.8867 15.5307 12.2136 14.7218 10.2531 14.7218C9.84438 14.7218 9.48691 14.7534 9.17612 14.8044C8.48632 14.9178 7.8435 15.2267 7.31142 15.6801L7.19599 15.7785L6.81982 16.1629L10.0763 22.2181H17.6171L22.5077 18.6465L25.8086 13.3646C25.4871 13.1228 25.1583 13.032 24.7797 13.0779ZM4.59463 15.1194L0.834473 17.0828L5.22969 25.501L9.09292 23.4844L4.59463 15.1194Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_238_4889"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white",
    transform: "translate(0.821533 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductIcon);
export default __webpack_public_path__ + "static/media/product-icon.c6af771f94e5d9d574b0f476afcb9904.svg";
export { ForwardRef as ReactComponent };